<template>
    <div class="grid grid-cols-1 gap-x-4 gap-y-3 py-3 sm:grid-cols-2">
        <div class="sm:col-span-1">
            <BaseInputText
                v-model="formValues.financial_assets"
                name="financial_conditions.financial_assets"
                :required="isRequiredLegalComplianceProfileAttribute('financial_conditions', 'financial_assets')"
                :icon="CreditCardIcon"
                :label="$t('financial_conditions.financial_assets')"></BaseInputText>
        </div>
        <div class="sm:col-span-1">
            <BaseInputText
                v-model="formValues.annual_operating_result"
                name="financial_conditions.annual_operating_result"
                :required="isRequiredLegalComplianceProfileAttribute('financial_conditions', 'annual_operating_result')"
                :icon="CreditCardIcon"
                :label="$t('financial_conditions.annual_operating_result')"></BaseInputText>
        </div>
        <div class="sm:col-span-1">
            <BaseInputText
                v-model="formValues.dept_capital"
                :required="isRequiredLegalComplianceProfileAttribute('financial_conditions', 'dept_capital')"
                name="financial_conditions.dept_capital"
                :icon="CreditCardIcon"
                :label="$t('financial_conditions.dept_capital')"></BaseInputText>
        </div>
        <div class="flex items-center pt-7 sm:col-span-1">
            <BaseInputCheckbox
                v-model="formValues.properties"
                :required="isRequiredLegalComplianceProfileAttribute('financial_conditions', 'properties')"
                name="financial_conditions.properties"
                :label="$t('financial_conditions.properties')"></BaseInputCheckbox>
        </div>
        <div class="sm:col-span-1">
            <BaseInputText
                v-model="formValues.industry"
                :required="isRequiredLegalComplianceProfileAttribute('financial_conditions', 'industry')"
                :icon="BriefcaseIcon"
                rules="min:2"
                name="financial_conditions.industry"
                :label="$t('financial_conditions.business_industry')"></BaseInputText>
        </div>
    </div>
    <div class="grid grid-cols-1 gap-x-4 gap-y-3 py-3 sm:grid-cols-2">
        <div class="pb-2 sm:col-span-2">
            <h3
                :class="[
                    'text-base font-bold text-gray-700',
                    {
                        'required': isRequiredLegalComplianceProfileAttribute(
                            'financial_conditions',
                            'source_of_funds'
                        ),
                    },
                ]">
                {{ $t('financial_conditions.source_of_funds') }}
            </h3>
        </div>
        <div class="sm:col-span-1">
            <BaseInputCheckbox
                v-model="formValues.source_of_funds.dividends_or_profits"
                name="financial_conditions.source_of_funds.dividends_or_profits"
                :label="$t('financial_conditions.dividends_or_profits_legal')" />
        </div>
        <div class="sm:col-span-1">
            <BaseInputCheckbox
                v-model="formValues.source_of_funds.insurance_claims"
                name="financial_conditions.source_of_funds.insurance_claims"
                :label="$t('financial_conditions.insurance_claims')" />
        </div>
        <div class="sm:col-span-1">
            <BaseInputCheckbox
                v-model="formValues.source_of_funds.loan"
                name="financial_conditions.source_of_funds.loan"
                :label="$t('financial_conditions.loan')" />
        </div>
        <div class="sm:col-span-1">
            <BaseInputCheckbox
                v-model="formValues.source_of_funds.sale_of_property"
                name="financial_conditions.source_of_funds.sale_of_property"
                :label="$t('financial_conditions.sale_of_property')" />
        </div>

        <div class="sm:col-span-1">
            <BaseInputCheckbox
                v-model="formValues.source_of_funds.retained_earnings"
                name="financial_conditions.source_of_funds.retained_earnings"
                :label="$t('financial_conditions.retained_earnings')" />
        </div>

        <div class="sm:col-span-1">
            <BaseInputTextActivatable
                v-model="formValues.source_of_funds.other"
                name="financial_conditions.source_of_funds.other"
                :label="$t('financial_conditions.other')"></BaseInputTextActivatable>
        </div>
    </div>
</template>

<script setup lang="ts">
import {
    getLegalWidgetFormValidationRules,
    initializeLegalWidgetForm,
    isRequiredLegalComplianceProfileAttribute,
    LegalFinancialConditions,
} from './forms'
import { BriefcaseIcon, CreditCardIcon } from '@heroicons/vue/solid'
import BaseInputCheckbox from '../../../../base/BaseInputCheckbox.vue'
import BaseInputText from '../../../../base/BaseInputText.vue'
import { useVModel } from '@vueuse/core'
import BaseInputTextActivatable from '../../../../base/BaseInputTextActivatable.vue'

const props = defineProps<{
    modelValue: LegalFinancialConditions
}>()

const emit = defineEmits(['update:modelValue'])
const formValues = useVModel(props, 'modelValue', emit)

initializeLegalWidgetForm(getLegalWidgetFormValidationRules('financial_conditions'))
</script>
